var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"screen-filters"},_vm._l((_vm.filterBtns),function(btn,idx){return _c('li',{key:'filter' + idx,staticClass:"screen-filters__btn",class:{ active: btn.active },style:({
      background: btn.active
        ? _vm.settings.filter.activeColor
        : _vm.bgColor,
      flexDirection: btn.iconPlacement === 'start' ? 'row' : 'row-reverse',
    })},[(btn.icon)?_c('a-icon',{style:({
        color: btn.active
          ? _vm.settings.filter.contentColor
          : _vm.settings.main.iconColor,
      }),attrs:{"type":btn.icon}}):_vm._e(),(btn.text)?_c('span',{style:({
        color: btn.active
          ? _vm.settings.filter.contentColor
          : _vm.settings.main.textColor,
      })},[_vm._v(_vm._s(btn.text))]):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }